import { render, staticRenderFns } from "./create_ch.vue?vue&type=template&id=ba5ee82e&scoped=true"
import script from "./create_ch.vue?vue&type=script&lang=js"
export * from "./create_ch.vue?vue&type=script&lang=js"
import style0 from "./create_ch.vue?vue&type=style&index=0&id=ba5ee82e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5ee82e",
  null
  
)

export default component.exports